import { UseLoadingReturn } from "@/hooks/use-loading";
import { IInsertUserProfile } from "@/interfaces/permission.interfaces";
import permissionService from "@/services/permissions.service";
import { RequestsProps } from "@/types/requests.types";

import useCreate from "../../use-create";

export type InsertUserProfileProps = RequestsProps & { formData: IInsertUserProfile };

export type UseInserUserProfileReturn = {
  insert: (props: InsertUserProfileProps) => Promise<void>;
} & UseLoadingReturn;

const useInserUserProfile = (): UseInserUserProfileReturn => {
  const {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    create: insert,
  } = useCreate<IInsertUserProfile>({
    operation: (formData) => permissionService.insertUserProfile(formData),
  });

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    insert,
  };
};

export default useInserUserProfile;
